import { Controller } from "@hotwired/stimulus"

// Controla el botón de compartir usando ClipboardJS
// Uso:
// - En el botón: data-controller="share-button" data-share-button-text-value="URL_TO_COPY" data-share-button-message-value="Mensaje de éxito"
// - El controlador inicializa ClipboardJS específicamente para este botón
export default class extends Controller {
  static values = {
    text: String,    // El texto/URL a copiar
    message: String  // El mensaje a mostrar cuando se copia exitosamente
  }

  connect() {
    console.log("Share Button controller connected")
    this.initClipboard()
  }

  disconnect() {
    // Limpiar el clipboard cuando el controlador se desconecta
    if (this.clipboard) {
      this.clipboard.destroy()
    }
  }

  initClipboard() {
    // Esperar a que ClipboardJS esté disponible
    this.waitForClipboardJS().then(() => {
      // Inicializar ClipboardJS para este botón específico
      this.clipboard = new ClipboardJS(this.element, {
        text: () => {
          return this.textValue
        }
      })

      // Manejar el evento de éxito
      this.clipboard.on('success', (e) => {
        console.log('Share button clipboard success:', e.text)
        this.showSuccessMessage()
        e.clearSelection()
      })

      // Manejar errores
      this.clipboard.on('error', (e) => {
        console.error('Share button clipboard error:', e)
        this.showErrorMessage()
      })

      console.log('ClipboardJS initialized for share button')
    })
  }

  waitForClipboardJS() {
    return new Promise((resolve) => {
      const checkClipboard = () => {
        if (typeof ClipboardJS !== 'undefined') {
          resolve()
        } else {
          console.log("Waiting for ClipboardJS to be available...")
          setTimeout(checkClipboard, 100)
        }
      }
      checkClipboard()
    })
  }

  showSuccessMessage() {
    const message = this.messageValue || 'Link copiado'
    
    // Usar alert por ahora, pero se puede mejorar con toast notifications
    alert(message)
    
    // Opcional: agregar feedback visual al botón
    this.addVisualFeedback()
  }

  showErrorMessage() {
    alert('Error al copiar el link')
  }

  addVisualFeedback() {
    // Agregar una clase temporal para feedback visual
    this.element.classList.add('btn-success')
    this.element.classList.remove('btn-outline-secondary')
    
    // Cambiar el icono temporalmente
    const icon = this.element.querySelector('i')
    if (icon) {
      const originalClass = icon.className
      icon.className = 'bi bi-check'
      
      // Restaurar después de 2 segundos
      setTimeout(() => {
        this.element.classList.remove('btn-success')
        this.element.classList.add('btn-outline-secondary')
        icon.className = originalClass
      }, 2000)
    }
  }
}
